import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  contentChildren,
  effect,
  input,
  model,
  viewChild,
} from '@angular/core';
import { NgStyle } from '@angular/common';
import {
  CdkOverlayOrigin,
  ConnectedPosition,
  OverlayModule,
} from '@angular/cdk/overlay';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { MenuItemDirective } from '../menu-item/menu-item.directive';
import { MenuTriggerDirective } from './menu-trigger.directive';

@Component({
  selector: 'et-atoms-menu',
  imports: [OverlayModule, NgStyle],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  isOpen = model(false);
  triggerLabel = input('More');
  triggerIcon = input('assets/icons/more.svg');
  triggerClass = input('flex items-center gap-1 text-midnight');
  width = input('fit-content');
  minWidth = input('200px');
  maxWidth = input('300px');
  closeOnClick = input(true, { transform: booleanAttribute });
  offsetX = input(0);
  offsetY = input(0);

  customTrigger = contentChild(MenuTriggerDirective);
  hasCustomTrigger = computed(() => !!this.customTrigger());
  origin = viewChild(CdkOverlayOrigin);

  menuItems = contentChildren(MenuItemComponent);
  menuItemDirectives = contentChildren(MenuItemDirective);

  menuPositions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
    },
  ];

  constructor() {
    effect((onCleanup) => {
      if (!this.closeOnClick()) {
        return;
      }

      for (const item of [...this.menuItems(), ...this.menuItemDirectives()]) {
        const sub = item.clicked.subscribe(() => this.isOpen.set(false));
        onCleanup(() => sub.unsubscribe());
      }
    });
  }

  /**
   * Toggles the menu open and close
   */
  toggle(): void {
    this.isOpen.update((open) => !open);
  }
}
